import { render, staticRenderFns } from "./PriceInputTable.vue?vue&type=template&id=54f054b0&scoped=true&"
import script from "./PriceInputTable.vue?vue&type=script&lang=js&"
export * from "./PriceInputTable.vue?vue&type=script&lang=js&"
import style0 from "./PriceInputTable.vue?vue&type=style&index=0&id=54f054b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f054b0",
  null
  
)

export default component.exports